"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.polyIcons = void 0;
const path_1 = __importDefault(require("path"));
let req;
let isSvg = false;
try {
    req = require.context('./tsx', true, /\.(tsx|js)?$/);
}
catch (e) {
    req = require.context('./svg', true, /\.svg?$/);
    isSvg = true;
}
const polyIcons = {};
exports.polyIcons = polyIcons;
const toExportName = (filename) => (/^\d/.test(filename) ? `Svg${filename}` : filename)
    .toLowerCase()
    .split('-')
    .map((word) => `${word.charAt(0).toUpperCase()}${word.slice(1)}`)
    .join('');
req.keys().forEach((file) => {
    const basename = path_1.default.basename(file, path_1.default.extname(file));
    const exportName = isSvg ? toExportName(basename) : basename;
    polyIcons[exportName] = req(file).default;
});
//# sourceMappingURL=index.js.map